// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"41288afe","146":"e11c6baa","243":"4a9ce1f7","555":"c57edce5","830":"3efb6ca0","901":"ec852c78"}[chunkId] + ".chunk.js";
};